/*
 |  tail.select - A solution to make (multiple) selection fields beatiful again, written in vanillaJS!
 |  @author     SamBrishes@pytesNET
 |  @version    0.4.2 - Beta
 |  @website    https://www.github.com/pytesNET/tail.select
 |
 |  @license    X11 / MIT License
 |  @copyright  Copyright © 2014 - 2018 SamBrishes, pytesNET <pytes@gmx.net>
 */
;(function(){
    if(!window.tail || !window.tail.select){
        return false;
    }
    window.tail.select.strings = {
        all: "Всё",
        none: "None",
        actionAll: "Выделить всё",
        actionNone: "Снять выбор",
        empty: "Нет доступных опций",
        emptySearch: "Опций не найдено",
        limit: "Вы не можете выбрать больше опций",
        placeholder: "Выберите опции",
        placeholderMulti: "Select up to :limit Options...",
        search: "Начните печатать"
    };
}());
